//@flow
import React from 'react';
import FormField from '../FormField';
import IosSwitch from '../../../../../elements/IosSwitch/IosSwitch';
import {useFormContext} from 'react-hook-form';
import {BLOG_FORM_FIELDS} from '../../../constants';
import {makeStyles} from '@material-ui/core';
import {useBlogFormDraftValue} from '../../../utils/blog-post';

const useStyles = makeStyles(theme => ({
  formSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '1rem',
    borderRadius: '.75rem',
    background: 'white',
  },
}));

export default function PostFeatured() {
  const classes = useStyles();

  const {updateDraft} = useBlogFormDraftValue();

  const {setValue, watch} = useFormContext();

  const postFeatured = watch(BLOG_FORM_FIELDS.postFeatured);
  return (
    <section className={classes.formSection}>
      <FormField
        title="8. Post destacado"
        subtitle="Los post destacados se muestran en la página de inicio."
        contentRight={
          <IosSwitch
            checked={!!postFeatured}
            onChange={e =>
              setValue(BLOG_FORM_FIELDS.postFeatured, e.target.checked)
            }
            onBlur={e => {
              updateDraft({
                [BLOG_FORM_FIELDS.postFeatured]: e.target.checked,
              });
            }}
          />
        }
      ></FormField>
    </section>
  );
}
